import styled from 'styled-components'

import { CardAction } from '~/components/card'
import _StepNumber from '~/components/step-number/step-number.component'
import _SubstepHeading from '~/components/substep-heading'
import { device } from '~/styles/utils'

import type { SubStepState } from './types'

export const SubStepContent = styled.div``
export const StepNumber = styled(_StepNumber)``
export const SubStepHeading = styled(_SubstepHeading)``
export const SubStepAction = styled(CardAction)``

/*
state active -> 2 columns
state NOT active -> 3 columns
showStepNumber adds 1 column
adjacentActionButton sets the 2nd column to `auto`
 */

const getGridTemplateColumn = (showStepNumber, adjacentActionButton) => {
  let value = adjacentActionButton ? 'auto' : '1fr'

  if (showStepNumber) {
    value = `min-content ${value}`
  }

  if (adjacentActionButton) {
    value = `${value} 1fr`
  } else {
    value = `${value} min-content`
  }

  return value
}

export const SubStepWrapper = styled.div<{
  $showStepNumber: boolean
  $state: SubStepState
  $adjacentActionButton?: boolean
}>`
  display: grid;
  grid-template-columns: ${({ $showStepNumber, $adjacentActionButton }) =>
    getGridTemplateColumn($showStepNumber, $adjacentActionButton)};
  grid-template-rows: min-content 1fr;
  gap: 13px;

  @media ${device('notMobile')} {
    row-gap: 18px;
  }

  ${StepNumber} {
    margin-right: 7px;
    grid-column: 1 / 2;
    grid-row: 1 / 2;
  }

  ${SubStepHeading} {
    grid-column: ${({ $showStepNumber }) => ($showStepNumber ? '2' : '1')};
    grid-row: 1;
    white-space: normal;
  }

  ${SubStepAction} {
    grid-column: 4;
    grid-row: 1;
  }

  ${SubStepContent} {
    grid-column-start: ${({ $state, $showStepNumber }) =>
      $state === 'active' || !$showStepNumber ? '1' : '2'};
    grid-column-end: ${({ $state }) => ($state === 'active' ? '-1' : '-2')};
    grid-row: 2;
  }

  color: ${({ theme }) => theme.color.text.default};
`
